import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SDate, SIcon, SLoad, SNavigation, SNotification, SOrdenador, SPage, SPopup, SScrollView2, SText, STheme, SView } from 'servisofts-component';
import Audio from '..';
import FloatButtom from '../../../Components/FloatButtom';
import { SSRolesPermisosValidate } from '../../../SSRolesPermisos';
import { DinamicTable } from 'servisofts-table';
import SSocket from 'servisofts-socket';
import PopupCrearAudio from '../Components/PopupCrearAudio';
import FloatMenu from '../../../Components/FloatMenu';
import Model from '../../../Model';
import PuntoDeVentaChoise from '../Components/PuntoDeVentaChoise';

class Lista extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sucursales: []
        };
    }

    async componentDidMount() {
        await SSocket.sendPromise({

            component: "sucursal",
            type: "getAll",
            estado: "cargando",
            key_usuario: this.props.state.usuarioReducer.usuarioLog.key,
        }).then(async (resp) => {
            this.setState({
                // sucursales: resp.data
                sucursales: Object.values(resp.data).filter(e => e.estado_app == 1)
            })

        }).catch(e => {

        })
    }



    async loadData() {

        var data = await SSocket.sendPromise({
            component: "audio",
            type: "getAll",
            estado: "cargando",
            key_usuario: this.props.state.usuarioReducer.usuarioLog.key,
        })

        if (!data) return <SLoad />;
       
        let datas = Object.values(data.data).map(e => ({
            ...e,
            sucursales: e.sucursales || []
        }));

        return datas;

    }

    onDeleteSucursal = (audio, key) => {

        audio.sucursales = audio.sucursales.filter(pv => pv !== key);
        console.log("AUDIO_", audio)

        SSocket.sendPromise({
            component: "audio",
            type: "editar",
            data: {
                key: audio.key,
                sucursales: audio.sucursales
            }

        }).then((resp) => {
            {
                // ...e.row,
                console.log(resp)
                this.DinamicTable.loadData();
            }
        })

        // Forzamos re-render del DinamicTable
        if (this.DinamicTable) {
            this.DinamicTable.forceUpdate();
        }
    };


    render() {

        return (
            <SPage disableScroll title={"Audios"}>

                <SView col={"xs-12"} padding={20}>
                    <DinamicTable
                        ref={ref => this.DinamicTable = ref}
                        loadData={this.loadData.bind(this)}
                        loadInitialState={async () => {
                            return {
                                sorters: [{ key: "fecha_on", order: 'desc', type: "date" }]
                            }
                        }}
                        onSelect={(e) => {
                            if (this.onSelect) {
                                this.onSelect(e.row);
                                SNavigation.goBack();
                                return;
                            }

                            const MenuOptions = [];
                            if (!SSRolesPermisosValidate({ page: "UsuarioPage", permiso: "edit" })) {
                                MenuOptions.push({
                                    icon: <SIcon name='Edit' />,
                                    label: "Editar Audio",
                                    onPress: () => {
                                        PopupCrearAudio.open({
                                            editObject: e?.row,
                                            onSuccess: () => {
                                                this.DinamicTable.loadData();
                                                // this.forceUpdate();
                                            }
                                        })
                                    }
                                })
                            }

                            if (!SSRolesPermisosValidate({ page: "UsuarioPage", permiso: "delete" })) {
                                MenuOptions.push({
                                    icon: <SIcon name='Delete' />,
                                    label: "Eliminar Audio",
                                    onPress: () => {
                                        SPopup.confirm({
                                            title: "Eliminar audio",
                                            message: "¿Estás seguro de eliminar este audio?",
                                            onPress: () => {

                                                const data = {
                                                    ...e.row,
                                                    estado: 0,
                                                }

                                                SSocket.sendPromise({
                                                    component: "audio",
                                                    type: "editar",
                                                    key_usuario: Model.usuario.Action.getKey(),
                                                    data: {
                                                        ...e.row,
                                                        estado: 0
                                                    }
                                                }).then((resp) => {
                                                    this.DinamicTable.loadData();
                                                }).catch(e => {

                                                })

                                            }
                                        })
                                    }
                                })
                            }

                            FloatMenu.open({
                                e: e.evt,
                                label: "Audio: " + e.row.name,
                                options: MenuOptions
                            })
                        }
                        }
                    >
                        <DinamicTable.Col key="index" label="#" width={40} data={(e) => e.index + 1} />
                        <DinamicTable.Col key={"key"} label="Key" data={e => e.row.key} />
                        <DinamicTable.Col key={"name"} label="Nombre" data={e => e.row.name} />
                        <DinamicTable.Col
                            key={"fecha_on"} label="F.Registro" width={120} dataType="date"
                            data={e => new SDate(e.row?.fecha_on, "yyyy-MM-ddThh:mm:ss").date}
                            textStyle={{ fontSize: 10, color: STheme.color.lightGray }} dateFormat="yyyy-MM-dd hh:mm"
                        />
                        <DinamicTable.Col width={310} key={"audio_"} label="Audio" data={e => e.row.key}
                            customComponent={e => <>
                                <audio controls src={`${SSocket.api.root}audio/${e.row?.key + ".mp3?time=" + new SDate().getTime()}`}></audio>
                            </>
                            }
                        />
                        <DinamicTable.Col width={400} key={"name_"} label="Puntos de ventas habilitados"
                            data={e => e.row}
                            customComponent={e => <PuntoDeVentaChoise
                                sucursales={this.state.sucursales}
                                all={e.row}
                                // data={e.row?.sucursales.map(a => a.key)}
                                data={e.row?.sucursales}
                                onAdd={(pv) => {
                                    e.row.sucursales.push(pv);

                                    SSocket.sendPromise({
                                        component: "audio",
                                        type: "editar",
                                        data: {
                                            key: e.row.key,
                                            sucursales: e.row.sucursales
                                        }

                                    }).then((resp) => {
                                        {
                                            // ...e.row,
                                            console.log(resp)
                                            this.DinamicTable.loadData();

                                        }
                                    })

                                }}
                                onDelete={(k) => this.onDeleteSucursal(e.row, k)}

                            />}

                        />
                    </DinamicTable>
                </SView>


                <FloatButtom esconder={!SSRolesPermisosValidate({ page: "UsuarioPage", permiso: "crear" })} onPress={() => {
                    PopupCrearAudio.open({
                        onSuccess: async () => {
                            this.DinamicTable.loadData();
                        },
                    })
                }} />
            </SPage>
        );
    }
}
const initStates = (state) => {
    return { state }
};
export default connect(initStates)(Lista);